export const COOKIE_NAME = decodeURIComponent('GWHS:INTERNAL');

export const ENDPOINT = 'https://internal.commerceplatform.services/';